import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import NewsletterForm from "./NewsletterForm";
import { useAuth } from "../lib/auth";

export default function Footer() {
  const { user } = useAuth();
  const isAdmin = user?.roles?.includes("admin");
  return (
    <footer className="mt-24 border-t border-border bg-background">
      <div className="bg-sidebar text-sidebar-fg py-12 border-b border-sidebar">
        <div className="container-page grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-gold">Between The Lines</div>
            <div className="font-display text-3xl sm:text-4xl tracking-tight mt-2 text-sidebar-fg">Join the readers&apos; club</div>
            <p className="text-sm text-sidebar-muted mt-2 italic max-w-md">A monthly letter, members-only offers, and the occasional free sampler. One click to leave.</p>
          </div>
          <div>
            <NewsletterForm variant="dark" source="footer" compact />
            <p className="text-xs text-sidebar-muted mt-3 italic">
              Or <Link to="/club" className="underline hover:text-gold">read more about the club</Link>.
            </p>
          </div>
        </div>
      </div>

      <div className="container-page py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div>
          <Logo className="h-24" />
          <p className="mt-3 text-muted-foreground leading-relaxed italic">stories that carry you home</p>
        </div>
        <div>
          <div className="font-medium mb-3 text-xs uppercase tracking-[0.18em] text-muted-foreground">Shop</div>
          <ul className="space-y-1.5 text-muted-foreground">
            <li><a href="/browse?category=ebooks" className="hover:text-accent">Ebooks</a></li>
            <li><a href="/browse?category=templates" className="hover:text-accent">Templates</a></li>
          </ul>
        </div>
        <div>
          <div className="font-medium mb-3 text-xs uppercase tracking-[0.18em] text-muted-foreground">Account</div>
          <ul className="space-y-1.5 text-muted-foreground">
            <li><Link to="/library" className="hover:text-accent">My library</Link></li>
            <li><Link to="/orders" className="hover:text-accent">Orders</Link></li>
            <li><Link to="/club" className="hover:text-accent">Between The Lines</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-medium mb-3 text-xs uppercase tracking-[0.18em] text-muted-foreground">Press</div>
          <ul className="space-y-1.5 text-muted-foreground">
            <li><Link to="/about" className="hover:text-accent">About</Link></li>
            <li><Link to="/blog" className="hover:text-accent">Journal</Link></li>
            <li><Link to="/contact" className="hover:text-accent">Contact</Link></li>
            <li><Link to="/terms" className="hover:text-accent">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-accent">Privacy</Link></li>
            <li><Link to="/refund-policy" className="hover:text-accent">Refund policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-accent">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="container-page pb-8 border-t border-border/60 pt-6 flex flex-wrap items-center justify-between gap-3 text-xs text-muted-foreground">
        <div>© {new Date().getFullYear()} Soft Spine Press. Digital downloads — no refunds for change of mind.</div>
        <Link
          to={isAdmin ? "/admin" : "/admin/login"}
          data-testid="footer-admin-link"
          className="inline-flex items-center gap-1.5 uppercase tracking-[0.18em] text-[10px] text-muted-foreground hover:text-accent transition-colors"
        >
          <span className="h-1 w-1 rounded-full bg-accent" /> {isAdmin ? "Admin dashboard" : "Administration"}
        </Link>
      </div>
    </footer>
  );
}
